/*
 * @license
 * Copyright (c) 2019, the Gago Inc All rights reserved.
 * @author: ZQ.xia (xiazhiqiang@gagogroup.com)
 * @created: 2019/1/18 9:33 AM
 */
import * as React from "react";
import styled from "styled-components";
import { BasicLegend2 } from "../basic-legend-2";
// tslint:disable-next-line: variable-name
const Root = styled(BasicLegend2) `
  .list {
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    .item {
      flex: 1 1 auto;
      flex-direction: column;
      &.not-active {
        .color {
          background-color: gray;
        }
      }
      display: flex;
      justify-content: center;
      .middle {
        display: flex;
        justify-content: center;
        flex: 1 1 65px;
      }
      .end {
        font-size: 12px;
        text-align: center;
        line-height: 12px;
        padding: 6px 12px;
      }
    }
  }
`;
// tslint:disable-next-line: variable-name
const Color = styled.div `
  background: ${props => props.color};
  width: 4px;
  border-radius: 1px;
`;
/**
 * 渐变图层无交互图例
 *
 * @author James Zhang
 * @author ZQ.Xia
 */
export class GradientSimpleLegend2 extends React.PureComponent {
    render() {
        const { names, colors } = this.props;
        let start;
        let end;
        start = names[0];
        end = names[names.length - 1];
        const min = colors[0][0];
        const max = colors[colors.length - 1][0];
        const gradientLinerColor = graidentColor(colors, min, max, "top");
        return (React.createElement(Root, { style: this.props.style, className: this.props.className, colorPalette: this.props.colorPalette, title: this.props.title, unit: this.props.unit },
            React.createElement("div", { className: "item" },
                end ? React.createElement("div", { className: "end" }, end) : undefined,
                React.createElement("div", { className: "middle" },
                    React.createElement(Color, { color: gradientLinerColor })),
                start ? React.createElement("div", { className: "end" }, start) : undefined)));
    }
}
GradientSimpleLegend2.defaultProps = {
    theme: "dark",
};
function graidentColor(colors, min, max, direction = "top") {
    const length = max - min;
    const colorsStr = colors.map(colorItem => {
        const [range, color] = colorItem;
        let precent = "";
        if (range) {
            precent = `${(((range - min) / length) * 100).toFixed(2)}%`;
        }
        return `${color} ${precent}`;
    });
    return `linear-gradient(to ${direction}, ${colorsStr.join()})`;
}
//# sourceMappingURL=index.js.map